import { useRouter } from 'next/navigation';

import { EEditMode } from '@/types/canvas';
import { EVENT } from '@/utils/event';
import { ROUTER_PATH } from '@/utils/router';

export interface OpenMemoryParams {
  noteId: string;
  mode?: EEditMode;
  ctdMode?: 'resonance' | 'ctd';
  analyzeText?: string[];
}

const useOpenMemoryDetail = (inMobile = false) => {
  const router = useRouter();

  const openMemoryDetail = (params: OpenMemoryParams, newTab = false) => {
    if (inMobile) {
      dispatchEvent(new Event(EVENT.HIDE_MODAL_CHAT));
      sessionStorage.setItem(`openMemoryNoteId`, params.noteId);
      newTab
        ? window.open(
            `${window.location.origin}${ROUTER_PATH.personalAIMemoryDetailMobile}`,
            '_blank'
          )
        : router.push(ROUTER_PATH.personalAIMemoryDetailMobile);

      return;
    }

    localStorage.setItem('openMemoryStartTime', Date.now().toString());
    const { noteId, mode, ctdMode, analyzeText } = params;

    sessionStorage.setItem(`openMemoryAnalyzeText_${noteId}`, analyzeText?.[0] || '');
    sessionStorage.setItem(`openMemoryMode_${noteId}`, mode || EEditMode.VIEW);
    sessionStorage.setItem(`openMemoryCtdMode_${noteId}`, ctdMode || 'ctd');
    sessionStorage.setItem(`openMemoryNoteId`, noteId);
    newTab
      ? window.open(`${window.location.origin}${ROUTER_PATH.personalAIMemoryDetail}`, '_blank')
      : router.push(ROUTER_PATH.personalAIMemoryDetail);
  };

  return {
    openMemoryDetail
  };
};

export default useOpenMemoryDetail;
